<div class="new-content" *ngIf="!pane; else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <section class="grid-card-universal" [class.mobile]="deviceService.isMobile()" #cardHolder>
    <div class="pane-header" *ngIf="blockTitle?.title || pane?.show_sorting" [class.mobile]="deviceService.isMobile()">
      <app-library-title [title]="blockTitle" [class.with-sorting]="pane?.show_sorting"></app-library-title>
      <app-library-sorting
        *ngIf="pane?.show_sorting"
        [class.with-more]="blockTitle?.see_all_link"
        [pane]="pane"></app-library-sorting>
    </div>
    <ng-template [ngIf]="isCarousel" [ngIfElse]="contentCards">
      <ng-container *ngTemplateOutlet="contentCardsCarousel; context: { carousel: isCarousel }"></ng-container>
    </ng-template>
    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <ng-template [ngIf]="isFavoritesPage && !contentData?.length">
      <app-empty [empty]="emptyObj"></app-empty>
    </ng-template>
  </section>
</ng-template>

<ng-template #contentCards let-carousel="carousel">
  <div class="infinity-content-cards" [class.scroll-viewport]="carousel" [class.with-carousel]="carousel" #scroller>
    <div
      *ngFor="let item of incrementalContent; trackBy: trackByFn"
      class="infinity-item item{{ itemsPerRow }}"
      [ngStyle]="{ 'flex-basis': carousel ? defaultItemsWidth + 'px' : 'none' }">
      <ng-container [ngSwitch]="cardType">
        <app-vertical-card
          *ngSwitchCase="'vertical'"
          [content]="item"
          (openCard)="onOpenCard($event)"></app-vertical-card>
        <app-vertical-square-card
          *ngSwitchCase="'vertical-square'"
          [content]="item"
          (openCard)="onOpenCard($event)"></app-vertical-square-card>
        <app-horizontal-card
          *ngSwitchCase="'horizontal'"
          [content]="item"
          (openCard)="onOpenCard($event)"></app-horizontal-card>
        <app-wide-vertical-card
          *ngSwitchCase="'wide-vertical'"
          [content]="item"
          (openCard)="onOpenCard($event)"></app-wide-vertical-card>
        <app-wide-horizontal-card
          *ngSwitchCase="'wide-horizontal'"
          [content]="item"
          (openCard)="onOpenCard($event)"></app-wide-horizontal-card>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #contentCardsCarousel let-carousel="carousel">
  <div class="carousel">
    <ng-template [ngIf]="carousel">
      <div class="right-btn" (click)="moveRight(scroller)">
        <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
      </div>

      <div class="left-btn" (click)="moveLeft(scroller)">
        <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
      </div>
    </ng-template>
    <ng-container *ngTemplateOutlet="contentCards; context: { carousel: isCarousel }"></ng-container>
  </div>
</ng-template>
